export const toCents = (value: number | string | null | undefined): number => {
    if (value === null || value === undefined || value === '') {
        return 0;
    }

    if (typeof value === 'number') {
        return Number.isFinite(value) ? Math.round(value * 100) : 0;
    }

    const trimmedValue = value.trim();

    if (!trimmedValue) {
        return 0;
    }

    const hasCommaSeparator = trimmedValue.includes(',');
    const normalizedValue = hasCommaSeparator
        ? trimmedValue.replace(/\./g, '').replace(',', '.')
        : trimmedValue.replace(/[^\d.-]/g, '');

    const parsedValue = Number(normalizedValue);

    return Number.isFinite(parsedValue) ? Math.round(parsedValue * 100) : 0;
};

export const fromCents = (value: number | string | null | undefined): number => {
    if (value === null || value === undefined || value === '') {
        return 0;
    }

    const numericValue = typeof value === 'string' ? Number(value) : value;

    return Number.isFinite(numericValue) ? numericValue / 100 : 0;
};
